import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component to normalize URLs by removing trailing slashes
 * This prevents duplicate content issues for SEO
 */
export default function TrailingSlashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // If the path has a trailing slash (except for root "/")
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      // Remove the trailing slash and redirect
      const newPath = location.pathname.slice(0, -1);
      navigate(newPath + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);

  return null;
}
